var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnApartment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-164 -281)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.16667V4.16667C14.1667 3.25 13.4167 2.5 12.5 2.5H7.5C6.58333 2.5 5.83333 3.25 5.83333 4.16667V5.83333H4.16667C3.25 5.83333 2.5 6.58333 2.5 7.5V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H8.33333C8.79167 17.5 9.16667 17.125 9.16667 16.6667V14.1667H10.8333V16.6667C10.8333 17.125 11.2083 17.5 11.6667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10.8333C17.5 9.91667 16.75 9.16667 15.8333 9.16667H14.1667ZM5.83333 15.8333H4.16667V14.1667H5.83333V15.8333ZM5.83333 12.5H4.16667V10.8333H5.83333V12.5ZM5.83333 9.16667H4.16667V7.5H5.83333V9.16667ZM9.16667 12.5H7.5V10.8333H9.16667V12.5ZM9.16667 9.16667H7.5V7.5H9.16667V9.16667ZM9.16667 5.83333H7.5V4.16667H9.16667V5.83333ZM12.5 12.5H10.8333V10.8333H12.5V12.5ZM12.5 9.16667H10.8333V7.5H12.5V9.16667ZM12.5 5.83333H10.8333V4.16667H12.5V5.83333ZM15.8333 15.8333H14.1667V14.1667H15.8333V15.8333ZM15.8333 12.5H14.1667V10.8333H15.8333V12.5Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -63.5,
    y: -65.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnApartment);
export default __webpack_public_path__ + "static/media/icn_apartment.0d1924a5f2c7b1c38424dcc8a985ddc0.svg";
export { ForwardRef as ReactComponent };